module.exports = __webpack_public_path__ + "static/media/drop_down_filter.70360449.svg";